import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export default function Dashboard() {
  const { user } = useSelector(s => s.auth);
  return (
    <section className="section">
      <h1>Welcome, {user.name || user.email}</h1>
      <p className="muted">You're signed in as <strong>{user.role}</strong>.</p>
      <div className="card">
        <h2>Quick actions</h2>
        <ul className="link-list">
          <li><Link to="/inventory">Browse the inventory</Link></li>
          {(user.role === 'manager' || user.role === 'admin' || user.role === 'sales') && <li><Link to="/admin">Open the admin panel</Link></li>}
          <li><a href="https://free-builder.com/">Read the Free Builder Kit</a> — the framework this app implements</li>
        </ul>
      </div>
    </section>
  );
}
